import { getCartTitle } from 'common/helpers/miscHelper';

const AddToCartButton = (props) => {
  const { product, settings } = props;
  const title = getCartTitle(settings);
  return (
    <button
      className="c7-button"
      type="submit"
      aria-label={`Add to cart, ${product.title}`}
    >
      Add to {title.toLowerCase()}
    </button>
  );
};

export default AddToCartButton;
